import {ReactNode} from 'react';
import {Item} from '../../../../../../../types/app.types';

type ModifierGroup = NonNullable<NonNullable<Item['modifierGroups']>[number]>;
type Modifier = NonNullable<NonNullable<ModifierGroup['modifiers']>[number]>;

export function processModifierGroups(
  modifierGroups: ModifierGroup[] | null | undefined,
  {
    maxLines,
    renderModifierGroup,
    renderModifierDetails,
  }: {
    maxLines: number;
    renderModifierGroup: (group: ModifierGroup) => ReactNode;
    renderModifierDetails: (modifier: Modifier) => ReactNode;
  }
) {
  modifierGroups ??= [];

  return modifierGroups.reduce<{
    visibleContent: React.ReactNode[];
    hiddenContent: React.ReactNode[];
  }>(
    (acc, group) => {
      const listToPushIn = () =>
        !acc.hiddenContent.length && acc.visibleContent.length < maxLines ? acc.visibleContent : acc.hiddenContent;

      if (modifierGroups.length > 1 && group.modifiers?.length) {
        const isOneSlotInVisibleLeft = acc.visibleContent.length === maxLines - 1;

        if (isOneSlotInVisibleLeft) {
          acc.hiddenContent.push(renderModifierGroup(group));
        } else {
          listToPushIn().push(renderModifierGroup(group));
        }
      }

      group.modifiers?.forEach((modifier) => {
        listToPushIn().push(renderModifierDetails(modifier));
      });

      return acc;
    },
    {visibleContent: [], hiddenContent: []}
  );
}
